// extracted by mini-css-extract-plugin
export default {"td":"ClientesIndex_td__xkyOu","inscricao":"ClientesIndex_inscricao__GRSH3"};